import './navigation';
import './skip-link-focus-fix';
import './components/button-list';
import './components/tag-toggle'
window.onload = function () {
  const searchFormEl = document.querySelector(".c-search-form_medium");

  if (searchFormEl) {
    const searchForm = searchFormEl.querySelector(".c-search-form__form");
    const searchInput = searchFormEl.querySelector(".c-search-form__input");
    const searchButton = searchFormEl.querySelector(".c-search-form__button");

    if (searchInput) {
      searchInput.addEventListener("focus", function (e) {
        this.classList.add("is-open");
      });
    }

    if (searchInput) {
      searchInput.addEventListener("blur", function (e) {
        if (!this.value) {
          searchInput.classList.remove("is-open");
        }
      });
    }

    // Only do search if there is a value in the search box
    if (searchButton) {
      searchButton.addEventListener("click", function (e) {
        // If user has typed something in search AND the bar isn't hidden then search
        if (searchInput.value) {
          searchForm.submit();
        } else {
          e.preventDefault();
          searchInput.focus();
        }
      });
    }
  }
};
